import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { School } from '../../../model/school.model';

@Injectable({
    providedIn: 'root'
})
export class SchoolEntityService extends EntityCollectionServiceBase<School> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('School', serviceElementsFactory);
    }
}
